<template>
    <div class="event-container" :class="contentAlignClass">
        <template
            v-if="
                eventDetail.eventTypeKey === 'goal' ||
                eventDetail.eventTypeKey === 'penGoal'
            "
        >
            <div class="event-type-goal-container">
                <div class="event-type-goal-caption-container">
                    <EventIcon
                        :cardType="eventDetail.eventTypeKey"
                        v-if="eventDetail.isHome && !isMobile"
                    />
                    <Icon
                        v-if="eventDetail.isHome && isMobile"
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 1"
                    ></Icon>
                    <Icon
                        v-if="!eventDetail.isHome"
                        :logoUrl="matchDetailScore.awayLogo"
                        hasClass="match-event-team-icon 2"
                    ></Icon>

                    <!-- :class="[
              eventDetail.isHome ? 'mr-05rem' : 'ml-05rem',
              { penGoal: eventDetail.eventTypeKey === 'penGoal' },
            ]" -->
                    <span
                        class="event-type-goal-caption mr-05rem ml-05rem"
                        :class="{
                            penGoal: eventDetail.eventTypeKey === 'penGoal',
                        }"
                        >{{ $t(cardCaption)
                        }}<template v-if="eventDetail.eventTypeKey === 'goal'"
                            >&nbsp;!!!</template
                        ></span
                    >

                    <EventIcon
                        :cardType="eventDetail.eventTypeKey"
                        v-if="
                            !eventDetail.isHome ||
                            (eventDetail.isHome && isMobile)
                        "
                    />
                    <Icon
                        v-if="eventDetail.isHome && !isMobile"
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 3"
                    ></Icon>
                </div>

                <div class="event-type-goal-score-container">
                    <Icon
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 4"
                    ></Icon>
                    <div class="match-goal-score-container">
                        <div>{{ eventDetail.homeScore }}</div>
                        <div>&nbsp;-&nbsp;</div>
                        <div>{{ eventDetail.awayScore }}</div>
                    </div>
                    <Icon
                        :logoUrl="matchDetailScore.awayLogo"
                        hasClass="match-event-team-icon 5"
                    ></Icon>
                </div>
            </div>
            <div class="event-detail goal-event-detail-container">
                <!-- <div
          v-if="eventDetail.videoUrl !== null && eventDetail.videoUrl !== ''"
          @click="$emit('clickVideo', eventDetail)"
          class="goal-event-video-thumnail"
        >
          <img src="../../../static/images/goal_video_preview.png" />
        </div> -->
                <div></div>
                <div>
                    <div class="player-name">{{ eventDetail.playerName }}</div>
                    <div class="event-name">{{ eventDetail.assistName }}</div>
                </div>
            </div>
        </template>

        <template v-else>
            <div
                class="event-type-container"
                :class="`event-${eventDetail.eventTypeKey}`"
                :style="
                    contentAlignClass === 'right-side'
                        ? 'flex-direction: row-reverse'
                        : ''
                "
            >
                <div class="event-type-goal-caption-container">
                    <Icon
                        v-if="
                            !eventDetail.isAway &&
                            eventDetail.isHome &&
                            isMobile
                        "
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 6"
                    ></Icon>

                    <Icon
                        v-if="!eventDetail.isHome"
                        :logoUrl="matchDetailScore.awayLogo"
                        hasClass="match-event-team-icon 7"
                    ></Icon>

                    <EventIcon
                        :cardType="eventDetail.eventTypeKey"
                        v-if="
                            !isMobile &&
                            contentAlignClass === 'right-side' &&
                            !isMobile
                        "
                    />

                    <!-- v-if="(!eventDetail.isHome || (eventDetail.isHome && isMobile)) && contentAlignClass === 'left-side' && !isMobile" -->

                    <div
                        v-if="
                            ['ownGoal', 'penMiss'].includes(
                                eventDetail.eventTypeKey
                            )
                        "
                        class="event-type-penalty-caption mr-05rem ml-05rem"
                    >
                        {{ $t(eventDetail.eventTypeKey) }}
                    </div>

                    <!-- <Icon
            v-if="eventDetail.isHome && isMobile"
            :logoUrl="matchDetailScore.homeLogo"
            hasClass="match-event-team-icon"
          ></Icon>
          <Icon
            v-if="!eventDetail.isHome"
            :logoUrl="matchDetailScore
            hasClass="match-event-team-icon"
          ></Icon> -->

                    <!-- :class="[
              eventDetail.isHome ? 'mr-05rem' : 'ml-05rem',
              { penGoal: eventDetail.eventTypeKey === 'penGoal' },
            ]" -->
                    <span
                        class="event-type-goal-caption mr-05rem ml-05rem"
                        v-if="
                            !['ownGoal', 'penMiss', 'var'].includes(
                                eventDetail.eventTypeKey
                            )
                        "
                        :class="{
                            penGoal: eventDetail.eventTypeKey === 'penGoal',
                        }"
                    >
                        {{ $t(cardCaption) }}
                    </span>
                    <EventIcon
                        :cardType="eventDetail.eventTypeKey"
                        :class="!isMobile ? '' : ''"
                        v-if="
                            (contentAlignClass === 'right-side' &&
                                !['ownGoal', 'penMiss', 'var'].includes(
                                    eventDetail.eventTypeKey
                                )) ||
                            isMobile
                        "
                    />
                    <SvgIcon
                        v-if="
                            ['ownGoal', 'penMiss', 'var'].includes(
                                eventDetail.eventTypeKey
                            ) &&
                            contentAlignClass === 'left-side' &&
                            !isMobile
                        "
                        :icon="`match.details.${eventDetail.eventTypeKey}`"
                    >
                    </SvgIcon>
                    <!-- (!eventDetail.isAway || (eventDetail.isAway && isMobile))  && contentAlignClass === 'right-side' -->
                    <!-- <SvgIcon
                        v-if="
                            (['ownGoal', 'penMiss', 'var'].includes(
                                eventDetail.eventTypeKey
                            ) &&
                                contentAlignClass === 'right-side') ||
                            isMobile
                        "
                        :icon="`match.details.${eventDetail.eventTypeKey}`"
                    >
                    </SvgIcon> -->
                    <Icon
                        v-if="eventDetail.isHome && !isMobile"
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 8"
                    ></Icon>
                </div>

                <div
                    class="event-type-goal-score-container"
                    v-if="
                        ['ownGoal', 'penMiss'].includes(
                            eventDetail.eventTypeKey
                        ) &&
                        eventDetail.homeScore &&
                        eventDetail.awayScore
                    "
                >
                    <Icon
                        :logoUrl="matchDetailScore.homeLogo"
                        hasClass="match-event-team-icon 9"
                    ></Icon>

                    <div class="match-goal-score-container">
                        <div>{{ eventDetail.homeScore }}</div>
                        <div>&nbsp;-&nbsp;</div>
                        <div>{{ eventDetail.awayScore }}</div>
                    </div>

                    <Icon
                        v-if="!isMobile"
                        :logoUrl="matchDetailScore.awayLogo"
                        hasClass="match-event-team-icon 8"
                    ></Icon>
                </div>
            </div>
            <!-- <div class="event-type" :class="eventDetail.eventType">
        <EventIcon
          :cardType="eventDetail.eventTypeKey"
          v-if="eventDetail.isHome && !isMobile"
        />
        <Icon
          v-if="!eventDetail.isHome"
          :logoUrl="matchDetailScore.awayLogo"
          hasClass="match-event-team-icon"
        ></Icon>
        <Icon
          v-if="eventDetail.isHome && isMobile"
          :logoUrl="matchDetailScoreLogo"
          hasClass="match-event-team-icon"
        ></Icon>

        <span class="event-type-caption ml-05rem mr-05rem">{{
          $t(cardCaption)
        }}</span>

        <EventIcon
          :cardType="eventDetail.eventTypeKey"
          v-if="!eventDetail.isHome || (eventDetail.isHome && isMobile)"
        />
        <Icon
          v-if="eventDetail.isHome && !isMobile"
          :logoUrl="matchDetailScoreLogo"
          hasClass="match-event-team-icon"
        ></Icon>
      </div> -->
            <div class="event-detail">
                <div class="player-name">{{ eventDetail.playerName }}</div>
                <div class="event-name">{{ eventDetail.assistName }}</div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import EventIcon from "@/components/indicator/EventIcon.vue";
export default {
    components: { EventIcon },
    emits: ["clickVideo"],
    props: {
        eventDetail: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters(["isMobile", "matchDetailScore"]),
    },
    data() {
        return {
            contentAlignClass: "",
            cardCaption: "",
            matchDetailScoreLocal: {},
        };
    },
    methods: {
        init() {
            this.setContentAlign();
            this.setCardCaption();
        },
        setContentAlign() {
            if (this.isMobile) this.contentAlignClass = "left-side";
            else
                this.contentAlignClass = this.eventDetail.isHome
                    ? "right-side"
                    : "left-side";
        },
        setCardCaption() {
            let eTypeKey = this.eventDetail.eventTypeKey;
            if (eTypeKey === "redcard") this.cardCaption = "RED_CARD";
            else if (eTypeKey === "yellowcard")
                this.cardCaption = "YELLOW_CARD";
            else if (eTypeKey === "yellowred")
                this.cardCaption = "YELLOW_RED_CARD";
            else if (eTypeKey === "goal") this.cardCaption = "GOAL";
            else if (eTypeKey === "penGoal") this.cardCaption = "PEN_SCORED";
            else if (eTypeKey === "var") this.cardCaption = "OFFSIDE";
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        matchDetailScore: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    // && this.eventDetail.eventTypeKey === "goal" || this.eventDetail.eventTypeKey === "penGoal";
                    this.matchDetailScoreLocal = newVal;
                }
            },
        },
    },
};
</script>

<style scoped>
.right-side {
    text-align: right !important;
}
.left-side {
    text-align: left !important;
}
.right-side .event-type {
    justify-content: flex-end;
}
.left-side .event-type {
    justify-content: flex-start;
}
.event-container {
    background: var(--color-background-default-tertiary);
    border-radius: var(--size-radius-200);
    border: 1px solid var(--color-border-default-default);
}
.event-type {
    display: flex;
    align-items: center;
    padding: var(--size-space-200);
    border-bottom: 1px solid var(--color-border-default-default);
    text-transform: capitalize;
}
.event-type-goal-container {
    border-top-left-radius: var(--size-radius-200);
    border-top-right-radius: var(--size-radius-200);
    background: var(--color-background-success-default);
    display: flex;
    justify-content: space-between;
    padding: var(--size-space-200);
    border-bottom: 1px solid var(--color-border-default-default);
    text-transform: capitalize;
}
.event-type-container {
    border-top-left-radius: var(--size-radius-200);
    border-top-right-radius: var(--size-radius-200);
    display: flex;
    justify-content: space-between;
    padding: var(--size-space-200);
    border-bottom: 1px solid var(--color-border-default-default);
    text-transform: capitalize;
}
.match-detail__info-timeline__left .event-type-container {
    justify-content: right;
}
.event-type-container .event-type-goal-caption {
    color: var(--color-text-default-default);
    text-transform: unset;
}
.event-type-container.event-penMiss,
.event-type-container.event-ownGoal {
    border-top-left-radius: var(--size-radius-200);
    border-top-right-radius: var(--size-radius-200);
    background: var(--color-background-error-default-hover);
    display: flex;
    justify-content: space-between;
    padding: var(--size-space-200);
    border-bottom: 1px solid var(--color-border-default-default);
    text-transform: capitalize;
}
.right-side .event-type-goal-container {
    flex-direction: row-reverse;
}
.event-detail {
    padding: var(--size-space-200);
}
.goal-event-detail-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.left-side .goal-event-detail-container {
    flex-direction: row-reverse;
}
.goal-event-video-thumnail {
    cursor: pointer;
}
.event-type-caption,
.player-name {
    color: var(--color-text-default-default);

    /* Caption Strong */
    font-family: var(--weight-600);
    font-size: var(--typography-caption-size-large);
    font-style: normal;
    /* line-height: normal; */
    letter-spacing: 0.2px;
}
.event-type-goal-caption {
    color: var(--tag-active-text);

    /* Caption Strong */
    font-family: var(--weight-600);
    font-size: var(--typography-caption-size-large);
    font-style: normal;
    letter-spacing: 0.2px;
    text-transform: uppercase;
}
.event-type-penalty-caption {
    color: var(--tag-active-text);

    /* Caption Strong */
    font-family: var(--weight-600);
    font-size: 13px;
    font-style: normal;
    letter-spacing: 0.2px;
}
.event-type-goal-caption-container {
    display: flex;
    align-items: center;
}
.event-type-goal-caption.penGoal {
    text-transform: capitalize !important;
    background: none;
}
.event-type-goal-score-container {
    display: flex;
    align-items: center;
}
.event-name {
    color: var(--color-text-default-secondary);

    /* Caption */
    font-family: var(--weight-600);
    font-size: var(--typography-caption-size-large);
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.2px;
}
.match-event-team-icon {
    width: 1.25rem;
    height: 1.25rem;
    padding: 0.104rem;
}
.match-goal-score-container {
    display: flex;
    justify-content: space-between;
    color: var(--tag-active-text);
    text-align: center;

    /* Body Small Strong */
    font-family: var(--typography-body-font-family);
    font-size: var(--typography-body-size-small);
    font-style: normal;
    font-family: var(--weight-700);
    font-weight: var(--weight-700);
    line-height: 140%; /* 19.6px */
    letter-spacing: 0.64px;
    margin: 0 0.5rem;
}
@media(max-width: 768px) {
    /* for test */

    .event-type-goal-caption,
    .event-type-caption {
        font-size: 13px;
    }
    .player-name {
        font-size: 13px;
    }
    .event-name {
        font-family: var(--weight-400);
    }
    .match-detail__info-timeline__left .event-type-container {
        justify-content: space-between;
    }
}
</style>
